import {Injectable} from "@angular/core";
import {RequesterService} from "../../../../shared/services/requester/requester.service";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../store";
import {combineLatest} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {Config} from "../../../../config/config";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import mockData from "../../../../../assets/json/mock-data.json";
import {BehaviorSubject} from "rxjs";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";

@Injectable()
export class NavigationService {
  private _ownerWorkspaceId: number;
  private _currentWorkspaceId: number;

  constructor(private _requester: RequesterService,
              private _httpClient: HttpClient,
              private _googleAnalyticsService: GoogleAnalyticsService,
              private _store: Store<DbStoreState>) {
    this._getWorkspaceEntities();
  }


  deleteMenu(domainId: string, menuId: number) {
    return this._requester.manager
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/navigation/actions/menu-delete-${menuId}`, null);
  }

  getMenuItems(domainId: string) {
    return this._requester.manager
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/navigation/actions/menu_item_types-all`, null, true);
  }

  getMenus(domainId: string) {
    return this._requester.manager
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/navigation/actions/menu-all`, null, true);
  }

  addMenu(domainId: string, data) {
    return this._requester.manager
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/navigation/actions/menu-add`, null, data);
  }

  updateMenu(domainId: string, data, menuId: number) {
    return this._requester.manager
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/navigation/actions/menu-update-${menuId}`, null, data);
  }

  getMenu(domainId: number, menuId: string) {
    if (domainId === Config.demoDomainId) {
      const response: any = mockData['navigation'];
      return new BehaviorSubject<DbResponse>(response);
    }
    return this._requester.manager
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/navigation/actions/menu-${menuId}`, null);
  }

  public sendAnalyticsEvent(label, websiteId) {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Website navigation',
      eventLabel: label,
      websiteId: websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _getWorkspaceEntities(): void {
    combineLatest(
      this._store.select(fromStore.getUserSubscription),
      this._store.select(fromStore.getWorkspaceIdEntities)
    ).subscribe(([userSubscription, workspaceIdEntities]) => {
      this._ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this._currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this._ownerWorkspaceId;
    });
  }

  decodeHtml(encodedString: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = encodedString;
    return textarea.value;
  }

}
